"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeJsonParse = safeJsonParse;
exports.safeLocalStorageGet = safeLocalStorageGet;
exports.safeSessionStorageGet = safeSessionStorageGet;
/**
 * 安全的JSON解析工具函数
 * 避免JSON.parse(undefined/null)导致的错误
 */

/**
 * 安全解析JSON字符串
 * @param {string|null|undefined} jsonString - 要解析的JSON字符串
 * @param {*} defaultValue - 默认值，当解析失败时返回
 * @returns {*} 解析后的对象或默认值
 */
function safeJsonParse(jsonString) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!jsonString) {
    return defaultValue;
  }
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.warn('JSON解析失败:', error);
    return defaultValue;
  }
}

/**
 * 安全从localStorage获取并解析JSON
 * @param {string} key - localStorage的键名
 * @param {*} defaultValue - 默认值
 * @returns {*} 解析后的对象或默认值
 */
function safeLocalStorageGet(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var jsonString = localStorage.getItem(key);
  return safeJsonParse(jsonString, defaultValue);
}

/**
 * 安全从sessionStorage获取并解析JSON
 * @param {string} key - sessionStorage的键名
 * @param {*} defaultValue - 默认值
 * @returns {*} 解析后的对象或默认值
 */
function safeSessionStorageGet(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var jsonString = sessionStorage.getItem(key);
  return safeJsonParse(jsonString, defaultValue);
}